/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NetworkSecurityPolicyModule
 */

import { Injector } from '@angular/core';

import {
    GeoDbCollection,
    GEO_DB_COLLECTION_TOKEN,
} from 'ajs/modules/geo-db';

import { NetworkSecurityPolicyCollection }
    from 'ajs/modules/network-security-policy/factories/network-security-policy.collection.factory';

import { NETWORK_SECURITY_POLICY_COLLECTION_TOKEN }
    from 'ajs/modules/network-security-policy/network-security-policy.tokens';

import { IPReputationDBCollection } from 'ajs/modules/ip-reputation-db';

const $injector = '$injector';

export const ipReputationDBCollectionProvider = {
    deps: [$injector],
    provide: IPReputationDBCollection,
    useFactory(injector: Injector): typeof IPReputationDBCollection {
        return injector.get('IPReputationDBCollection');
    },
};

export const geoDbCollectionProvider = {
    deps: [$injector],
    provide: GeoDbCollection,
    useFactory(injector: Injector): typeof GeoDbCollection {
        return injector.get(GEO_DB_COLLECTION_TOKEN);
    },
};

export const networkSecurityPolicyCollectionProvider = {
    deps: [$injector],
    provide: NetworkSecurityPolicyCollection,
    useFactory(injector: Injector): typeof NetworkSecurityPolicyCollection {
        return injector.get(NETWORK_SECURITY_POLICY_COLLECTION_TOKEN);
    },
};
